export default __webpack_public_path__ + "static/media/indicator_carousel3.2571ce73.png";